import styled from 'styled-components';

export const TextWrapper = styled.footer`
  display: flex;
  justify-content: center;
  padding: 2em 0;
  color: ${props => props.theme.color.footerText};
`;
